import { Route, Routes } from "react-router-dom";
import { Layout } from "./layout/Layout";
import Home from "./pages/Home";
import CartPage from "./pages/CartPage";
import NotFound from "./pages/NotFound";
import "./App.css";
import CategoryPage from "./pages/CategoryPage";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="category/:id" element={<CategoryPage />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
